import type { ConfigType } from "../constants/config";

export const resolveRelativePath = (path: string, config: ConfigType) => {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  if (location.href.startsWith(config.chatUrl)) {
    return concatUrlIfNeeded(config.chatUrl, path);
  }

  return concatUrlIfNeeded(config.appUrl, path);
};

const concatUrlIfNeeded = (baseUrl: string, pathname: string) => {
  const concatenatedPath = baseUrl.concat(pathname);
  const origin = new URL(concatenatedPath).origin;

  const pathnameFromOrigin = concatenatedPath.substring(origin.length);
  if (pathnameFromOrigin !== pathname) {
    return concatenatedPath;
  }

  return pathname;
};
